import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DesignerListSection, DesignerListSectionLinks } from '../DesignerList/index';
import Wrapper from '../DesignerList/styled/Wrapper';
import { alphabet, displayAlphabet } from '../../helpers/alphabet';
import BackToTopButton from '../BackToTopButton';
import { easeInOutQuint, scrollElementToCenter, scrollElementToTop } from '../../helpers/animatedScrolling';
import { TrackingEvents } from '../../common/models';
import { track } from '../../helpers/tracking';

const mapStateToProps = ({ api: { designers, department } }) => ({
  designers,
  department,
});

class DesignerList extends Component {
  constructor(props) {
    super(props);

    this.sectionRefs = alphabet.map(() => React.createRef());
  }

  componentDidMount() {
    const { department } = this.props;
    track(TrackingEvents.designersViewed(), { categoryDepartment: { department } });
  }

  onClickLetter = (letter, callback) => {
    const { designers } = this.props;

    const idx = displayAlphabet().indexOf(letter);
    if (idx !== -1 && designers[alphabet[idx]] !== undefined) {
      const el = this.sectionRefs[idx].current;
      callback(el);
    }
  };

  onClickDesktop = letter => {
    this.onClickLetter(letter, el => scrollElementToCenter(el, 1500, easeInOutQuint));
  };

  onClickMobile = letter => {
    this.onClickLetter(letter, el => scrollElementToTop(el, 1500, easeInOutQuint));
  };

  render() {
    const { designers } = this.props;

    const availableAlphabet = displayAlphabet().filter((letter, index) => designers[alphabet[index]] !== undefined);
    return (
      <Wrapper>
        <DesignerListSectionLinks
          alphabet={displayAlphabet()}
          availableAlphabet={availableAlphabet}
          onClickDesktop={this.onClickDesktop}
          onClickMobile={this.onClickMobile}
        />
        {displayAlphabet().map((letter, index) => (
          <div key={letter} ref={this.sectionRefs[index]}>
            <DesignerListSection letter={letter} designers={designers[alphabet[index]]} />
          </div>
        ))}
        <BackToTopButton />
      </Wrapper>
    );
  }
}

DesignerList.propTypes = {
  designers: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(DesignerList);
